import { render, staticRenderFns } from "./jackpot-list.vue?vue&type=template&id=20c54391&scoped=true"
import script from "./jackpot-list.vue?vue&type=script&lang=js"
export * from "./jackpot-list.vue?vue&type=script&lang=js"
import style0 from "./jackpot-list.vue?vue&type=style&index=0&id=20c54391&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c54391",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/jackpot-list.vue
// module id = IgQz
// module chunks = 0